import React, { useEffect } from 'react';
import { sanitizeHtml } from '../../utils/Tools';
import { IState, ReduxMap } from '../../redux/redux';
import { INomination, INominationInfo } from './NominationTypes';
import StoreX, { store } from '../../redux/oldStore';
import { ServerResponse } from '../../utils/Server';
import { toast } from 'react-toastify';
import Button from '../_Core/Button';
import Select from 'react-select';
import { IProjectInfo } from '../_Core/CoreTypes';
import { Selectable } from '../../utils/CommonTypes/CommonTypes';
import Modal from '../Modal/Modal';
import Icon, { IconType } from '../Icon/Icon';
import ProjectDetailsWraper from '../Showcase/projectDetailsWraper';
import CreatableSelect from 'react-select/creatable';

interface NominationsReviewProps extends IState {}

const StatusOptions = ['Pending', 'Approved', 'Rejected'];
const GroupByOptions = ['Nomination', 'Project', 'Award'];

const NominationsReview = (props: NominationsReviewProps) => {
  const [data, setData] = React.useState<INominationInfo>();
  const [projectDic, setProjectDic] = React.useState<Record<number, IProjectInfo>>({});
  const [filterNomination, setFilterNomination] = React.useState<INomination[]>([]);
  const [projectsNominationsDic, setProjectsNominationsDic] = React.useState<Record<number, INomination[]>>({});
  const [searchOptions, setSearchOptions] = React.useState<Selectable[]>([]);
  const [selectedOptions, setSelectedOptions] = React.useState<Selectable[]>([]);

  const [sortOptions, setSortOptions] = React.useState<Selectable[]>([]);
  const [sortOption, setSortOption] = React.useState<Selectable>();

  const [modalOpen, setModalOpen] = React.useState<boolean>(false);
  const [selectedNomination, setSelectedNomination] = React.useState<INomination>();
  const [selectedProject, setSelectedProject] = React.useState<IProjectInfo>();
  const [selectedAward, setSelectedAward] = React.useState<string>();
  const [showShowcase, setShowShowcase] = React.useState<boolean>(false);
  const [itemsPerPage, setItemsPerPage] = React.useState<number>(20);
  const [currentPage, setCurrentPage] = React.useState<number>(1);
  const [totalPages, setTotalPages] = React.useState<number>(1);
  const [groupBy, setGroupBy] = React.useState<Selectable>();
  const [groupOptions, setGroupOptions] = React.useState<Selectable[]>([]);
  const [reloading, setReloading] = React.useState<boolean>(false);

  useEffect(() => {
    setSortOptions([
      // { label: 'Sort: Newest', value: 'newest' },
      // { label: 'Sort: Oldest', value: 'oldest' },
      { label: 'Sort: Entry ID', value: 'projectId' },
      { label: 'Sort: Title', value: 'title' },
      { label: 'Sort: Award', value: 'award' },
    ]);
    setSortOption({ label: 'Sort: Title', value: 'projectId' });
    setGroupOptions([
      { label: 'Group By: Nomination', value: 'Nomination' },
      { label: 'Group By: Entry', value: 'Entry' },
      { label: 'Group By: Award', value: 'Award' },
      { label: 'Group By: Award-Entry', value: 'Award-Entry' },
    ]);
    setGroupBy({ label: 'Group By: Entry', value: 'Entry' });
    init();
  }, []);

  useEffect(() => {
    if (data && !reloading) {
      //build search options here...
      let options: Selectable[] = [];

      let subOptions: Selectable[] = [];
      data.categories.forEach((c) => {
        subOptions.push({ value: `cate:${c.id}`, label: c.name });
      });
      options.push({ label: 'Categories', value: '', options: subOptions });

      subOptions = [];
      data.specialAwards.forEach((c) => {
        subOptions.push({ value: `award:${c.id}`, label: c.name });
      });
      options.push({ label: 'Special Awards', value: '', options: subOptions });

      subOptions = [];
      StatusOptions.forEach((c) => {
        subOptions.push({ value: `status:${c}`, label: c });
      });
      subOptions.push({ value: `status-show:Rejected`, label: 'Show Rejected' });

      options.push({ label: 'Status', value: '', options: subOptions });

      subOptions = [];
      data.affiliates.forEach((c) => {
        subOptions.push({ value: `affiliate:${c.id}`, label: c.name });
      }
      );
      options.push({ label: 'Affiliates', value: '', options: subOptions });

      setSearchOptions(options);

    }
  }, [data]);

  useEffect(() => {
    if (groupBy) {
      if (groupBy.value === 'Nomination') {
        setItemsPerPage(25);
        setSortOption({ label: 'Sort: Entry ID', value: 'projectId' });
      } else if (groupBy.value === 'Entry') {
        setItemsPerPage(20);
        setSortOption({ label: 'Sort: Entry ID', value: 'projectId' });
      } else if (groupBy.value === 'Award') {
        setItemsPerPage(20);
        setSortOption({ label: 'Sort: Award', value: 'award' });
      }
    }
  }, [groupBy]);

  useEffect(() => {
    if (data) {
      //Apply searches here...
      setFilterNomination(data.nominations);
    }
  }, [data]);

  useEffect(() => {
    if (data) {
      let filter = data.nominations;
      let showRejected = selectedOptions.find((x) => x.value === 'status-show:Rejected');
      if (!showRejected) {
        filter = filter.filter((x) => x.ReviewStatus !== 'Rejected');
      }

      let preFiltered = [...filter];

      selectedOptions.forEach((x) => {
        let parts = x.value.toString().split(':');
        let type = parts[0];
        let idStr = parts[1];
        let id = parseInt(parts[1]);
        if (type === 'cate') {
          filter = filter.filter((n) => {
            let project = projectDic[n.ProjectId];
            return project && project.categoryId === id;
          });
        } else if (type === 'award') {
          filter = filter.filter((n) => {
            return n && n.SpecialAwardId === id;
          });
        } else if (type === 'proj') {
          filter = filter.filter((n) => {
            return n && n.ProjectId === id;
          });
        } else if (type === 'status') {
          filter = filter.filter((n) => {
            return n && n.ReviewStatus === idStr;
          });
        }
        else if (type === 'affiliate') {
          filter = filter.filter((n) => {
            let project = projectDic[n.ProjectId];
            return project && project.affiliateId === id;
          });
        } else if (parts.length === 1) {
          let v = x.value.toString()?.toLowerCase() || '';
          filter = filter.filter((n) => {
            let project = projectDic[n.ProjectId];
            return (
              n.Reason?.toLowerCase().includes(v) ||
              n.NominationType?.toLowerCase().includes(v) ||
              (project && (project.title?.toLowerCase().includes(v) ?? false)) ||
              (project && (project.projectId?.toString().toLowerCase().includes(v) ?? false)) ||
              (project && (project.categoryName?.toLowerCase().includes(v) ?? false)) ||
              (n.ReviewStatus?.toLowerCase().includes(v) ?? false)
            );
          });
        }
      });

      //Sort the nominations based on the selected sort option
      filter = sortList(filter);
      preFiltered = sortList(preFiltered);

      let projectsNomDic:Record<number, INomination[]> = {};
      preFiltered.forEach((x) => {
        if (!projectsNomDic[x.ProjectId]) {
          projectsNomDic[x.ProjectId] = [];
        }
        projectsNomDic[x.ProjectId].push(x);
      });
      setProjectsNominationsDic(projectsNomDic);
      console.log('projectsNominationsDic', projectsNomDic);

      setFilterNomination(filter);

      // After all filtering and sorting is done:
      setTotalPages(Math.ceil(filter.length / itemsPerPage));

      if(!reloading){
      
      
      // Reset to first page when filters change
      setCurrentPage(1);
      } else{
        //remove reloading flag? not sure if this is needed...
      }
    }
  }, [selectedOptions, sortOption, data]);

  const sortList= (list: INomination[]) => {
    let filter = [...list];

      if (sortOption) {
        let sortBy = sortOption.value.toString();

        if (sortBy === 'projectId') {
          filter = filter.sort((a, b) => {
            let projectA = projectDic[a.ProjectId];
            let projectB = projectDic[b.ProjectId];
            if (!projectA && !projectB) {
              return 0;
            }
            if (!projectA) {
              return 1; // projectB comes first
            }
            if (!projectB) {
              return -1; // projectA comes first
            }
            if(typeof projectA.projectId === 'number' && typeof projectB.projectId === 'number') {              
              return (0+projectA.projectId) - (0+projectB.projectId);
            }
            //return projectA.projectId.localeCompare(projectB.projectId);
            return projectA.projectId.toLowerCase() > projectB.projectId.toLowerCase() ? 1 : -1;
          });
        } else if (sortBy === 'title') {
          filter = filter.sort((a, b) => {
            let projectA = projectDic[a.ProjectId];
            let projectB = projectDic[b.ProjectId];
            if (!projectA || !projectB) {
              return 0;
            }
            //return projectA.title.localeCompare(projectB.title);
            return projectA.title.toLowerCase() > projectB.title.toLowerCase() ? 1 : -1;
          });
        } else if (sortBy === 'award') {
          filter = filter.sort((a, b) => {
            let awardA = data.awardsDic[a.SpecialAwardId];
            let awardB = data.awardsDic[b.SpecialAwardId];
            if (!awardA || !awardB) {
              return 0;
            }
            //return awardA.localeCompare(awardB);
            return awardA.toLowerCase() > awardB.toLowerCase() ? 1 : -1;
          });
        }
      }
      console.log('Sorted nominations', filter.map(x=>projectDic[x.ProjectId]?.projectId));
      return filter;
  };

  const saveReview = () => {
    if (!selectedNomination) {
      return;
    }
    store.server.postApi<ServerResponse<INomination>>('../SpecialAwardNominations/SaveNominationReview', selectedNomination).then((x) => {
      if (x.Success) {
        toast.success('Nomination Reviewed');
        setModalOpen(false);
        init(true);
      } else {
        console.error(x);
        toast.error(x.Message, { autoClose: false });
      }
    });
  };

  const quickSetStatus = (status: 'Pending'| 'Approved'| 'Rejected', noms:INomination[], project: IProjectInfo) => {
    let request = {
      status: status,
      nominations: noms.map((x) => {
        return x.Id;
      }),
    };
    store.server.postApi<ServerResponse<INomination>>('../SpecialAwardNominations/SaveNominationReviewQuick', request).then((x) => {
      if (x.Success) {
        toast.success(`Nomination status set to ${status} for ${project.projectId}`);
        init(true);
      } else {
        console.error(x);
        toast.error(x.Message, { autoClose: false });
      }
    });
  }

  const init = (isReload?:boolean) => {
    if(isReload) {
      setReloading(true);
    }
    store.server.getApi<ServerResponse<INominationInfo>>('../SpecialAwardNominations/Nominations').then((x) => {
      if (x.Success) {
        let dic: Record<number, IProjectInfo> = {};
        x.Value.projects.forEach((p) => {
          dic[p.id] = p;
        });
        setProjectDic(dic);
        setData(x.Value);
      } else {
        console.error(x);
        toast.error(x.Message, { autoClose: false });
      }
    });
  };

  const mapRankings = (projectId:number) => {
    const rankings = data?.rankings ? data?.rankings[projectId] || [] : [];
    if( rankings.length === 0) {
      return <></>;
    }
    else {
      return <div className="rankings">
        {rankings.map((r, i) => {
          return (<span key={i} className={r.IsFinals ? 'ranking finals' : 'ranking'}>{r.Rank} - {r.RoundName}</span>
            
          );
        })}
      </div>
    }

  };

  const mapNominations = () => {
    switch (groupBy?.value) {
      case 'Award':
        {
          let groupedByAward: Record<number, INomination[]> = {};
          let index = [];
          filterNomination.forEach((x) => {
            if (!groupedByAward[x.SpecialAwardId]) {
              groupedByAward[x.SpecialAwardId] = [];
              index.push(x.SpecialAwardId);
            }
            groupedByAward[x.SpecialAwardId].push(x);
          });
          return (
            <div>
              {index.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((key, i) => {
                let awardNominations = groupedByAward[key];
                let award = data?.awardsDic[key];
                if (!award) {
                  return null;
                }
                return (
                  <div key={i}>
                    <div className="nomination-card">
                      <div className="award-name">{award}</div>
                      {awardNominations.map((x, j) => {
                        let project = projectDic[x.ProjectId];
                        if (!project) {
                          return null;
                        }
                        return (
                          <div key={j} className="flex-between noms">
                            <div className="flex">
                              <div className="nomination-status">
                                {getStatusIcon(x.ReviewStatus)}
                                <div>{x.ReviewScore && <>{x.ReviewScore}</>}</div>
                                <br />
                                <Button
                                  type="edit"
                                  text="Review"
                                  extraSmall={true}
                                  onClick={() => {
                                    setSelectedNomination(x);
                                    setSelectedProject(project);
                                    setSelectedAward(award);
                                    setModalOpen(true);
                                  }}
                                />
                              </div>
                              <div>
                                <div className="project-id">
                                  {project.projectId}
                        {project.affiliateCode && <span className="affiliate-code">{project.affiliateCode}</span>}
                                  {'  '}
                                  <Button
                                    type="details"
                                    extraSmall={true}
                                    iconOnly={true}
                                    onClick={() => {
                                      setSelectedProject(project);
                                      setShowShowcase(true);
                                    }}
                                  />
                                </div>
                                <div className="nomination-type">Type: {x.NominationType}</div>
                                <div className="nomination-category">{project.categoryName}</div>
                                {mapRankings(project.id)}
                              </div>
                            </div>
                            <div className="title" dangerouslySetInnerHTML={{ __html: sanitizeHtml(project.title) }}></div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          );
        }
        break;
      
      case 'Award-Entry':
        {
          let groupedByAward: Record<number, INomination[]> = {};
          let index = [];
          filterNomination.forEach((x) => {
            if (!groupedByAward[x.SpecialAwardId]) {
              groupedByAward[x.SpecialAwardId] = [];
              index.push(x.SpecialAwardId);
            }
            groupedByAward[x.SpecialAwardId].push(x);
          });
          return (
            <div>
              {index.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((key, i) => {
                let awardNominations = groupedByAward[key];
                let award = data?.awardsDic[key];
                if (!award) {
                  return null;
                }

                let projectIds = [];
                let projectHash = {};
                awardNominations.forEach((x) => {
                  if (!projectHash[x.ProjectId]) {
                    projectIds.push(x.ProjectId);
                    projectHash[x.ProjectId] = x;
                  }
                });

                return (
                  <div key={i}>
                    <h3>{award}</h3>
                    {projectIds.map((projKey, projIndex)=>{
                      let projectNominations = projectsNominationsDic[projKey];
                      let project = projectDic[projKey];
                      if (!project) {
                        return null;
                      }
                      return (
                    <div className="nomination-card" key={projKey}>
                      <div className="award-name">
                        {project.affiliateCode && <span className="affiliate-code">{project.affiliateCode}</span>}
                        {project.projectId} - {project.title}
                        
                        <Button
                                      type="details"
                                      extraSmall={true}
                                      iconOnly={true}
                                      onClick={() => {
                                        setSelectedProject(project);
                                        setShowShowcase(true);
                                      }}
                                    />
                      </div>
                      {projectNominations.map((x, j) => {
                        let award = data?.awardsDic[x.SpecialAwardId];
                        return (
                          <div key={j} className="flex-between noms">
                            <div className="flex">
                              <div className="nomination-status">
                                {getStatusIcon(x.ReviewStatus)}
                                <div>{x.ReviewScore && <>{x.ReviewScore}</>}</div>
                              </div>
                              <div>
                                <div className="project-id">
                                  {award}
                                </div>
                                <div className="btn-group">
                                  {(x.ReviewStatus ? false : true) && (
                                    <>
                                      <Button
                                        type="reject"
                                        text="Reject"
                                        extraSmall={true}
                                        onClick={() => {
                                          quickSetStatus('Rejected', [x], project);
                                        }}
                                      />
                                      <Button
                                        type="approve"
                                        text="Approve"
                                        extraSmall={true}
                                        onClick={() => {
                                          quickSetStatus('Approved', [x], project);
                                        }}
                                      />
                                    </>
                                  )}
                                  <Button
                                    type="edit"
                                    text="Review"
                                    extraSmall={true}
                                    onClick={() => {
                                      setSelectedNomination(x);
                                      setSelectedProject(project);
                                      setSelectedAward(award);
                                      setModalOpen(true);
                                    }}
                                  />
                                </div>
                                <div className="nomination-type">Type: {x.NominationType}</div>
                                <div className="nomination-category">{project.categoryName}</div>
                              </div>
                            </div>
                            <div className="nomination-card-reason" dangerouslySetInnerHTML={{ __html: sanitizeHtml(x.Reason) }}></div>
                          </div>
                        );
                      })}
                      <div className="nomination-card-footer flex-between">
                        <div className="btn-group">
                          <Button extraSmall={true} type="reject" text="Reject All Nominations" onClick={() => {
                            quickSetStatus('Rejected', projectNominations, project);
                          }} />
                          <Button extraSmall={true} type="approve" text="Approve All Nominations" onClick={() => {
                            quickSetStatus('Approved', projectNominations, project);}} />
                        </div>
                                {mapRankings(project.id)}
                      </div>
                    </div>
                    );})}
                  </div>
                );
              })}
            </div>
          );
        }
        break;
      case 'Entry':
        {
          let groupedByProject: Record<number, INomination[]> = {};
          let index = [];
          filterNomination.forEach((x) => {
            if (!groupedByProject[x.ProjectId]) {
              groupedByProject[x.ProjectId] = [];
              index.push(x.ProjectId);
            }
            groupedByProject[x.ProjectId].push(x);
          });
          return (
            <div>
              {index.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((key, i) => {
                let projectNominations = groupedByProject[key];
                let project = projectDic[key];
                if (!project) {
                  return null;
                }
                return (
                  <div key={i}>
                    <div className="nomination-card">
                      <div className="award-name">
                        {project.affiliateCode && <span className="affiliate-code">{project.affiliateCode}</span>}
                        {project.projectId} - {project.title}
                        
                        <Button
                                      type="details"
                                      extraSmall={true}
                                      iconOnly={true}
                                      onClick={() => {
                                        setSelectedProject(project);
                                        setShowShowcase(true);
                                      }}
                                    />
                      </div>
                      {projectNominations.map((x, j) => {
                        let award = data?.awardsDic[x.SpecialAwardId];
                        return (
                          <div key={j} className="flex-between noms">
                            <div className="flex">
                              <div className="nomination-status">
                                {getStatusIcon(x.ReviewStatus)}
                                <div>{x.ReviewScore && <>{x.ReviewScore}</>}</div>
                              </div>
                              <div>
                                <div className="project-id">
                                  {award}
                                </div>
                                <div className="btn-group">
                                  {(x.ReviewStatus ? false : true) && (
                                    <>
                                      <Button
                                        type="reject"
                                        text="Reject"
                                        extraSmall={true}
                                        onClick={() => {
                                          quickSetStatus('Rejected', [x], project);
                                        }}
                                      />
                                      <Button
                                        type="approve"
                                        text="Approve"
                                        extraSmall={true}
                                        onClick={() => {
                                          quickSetStatus('Approved', [x], project);
                                        }}
                                      />
                                    </>
                                  )}
                                  <Button
                                    type="edit"
                                    text="Review"
                                    extraSmall={true}
                                    onClick={() => {
                                      setSelectedNomination(x);
                                      setSelectedProject(project);
                                      setSelectedAward(award);
                                      setModalOpen(true);
                                    }}
                                  />
                                </div>
                                <div className="nomination-type">Type: {x.NominationType}</div>
                                <div className="nomination-category">{project.categoryName}</div>
                              </div>
                            </div>
                            <div className="nomination-card-reason" dangerouslySetInnerHTML={{ __html: sanitizeHtml(x.Reason) }}></div>
                          </div>
                        );
                      })}
                      <div className="nomination-card-footer flex-between">
                        <div className="btn-group">
                          <Button extraSmall={true} type="reject" text="Reject All Nominations" onClick={() => {
                            quickSetStatus('Rejected', projectNominations, project);
                          }} />
                          <Button extraSmall={true} type="approve" text="Approve All Nominations" onClick={() => {
                            quickSetStatus('Approved', projectNominations, project);}} />
                        </div>
                                {mapRankings(project.id)}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          );
        }
        break;
      case 'Nomination':
      default:
        return (
          <div>
            {data &&
              filterNomination.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((x, i) => {
                let award = data.awardsDic[x.SpecialAwardId];
                let project = projectDic[x.ProjectId];
                if (!project) {
                  return null;
                }
                //let category = data.cateDic[project.categoryId];
                return (
                  <div key={i} className="nomination-card">
                    <div className="award-name">{award}</div>
                    <div className="flex-between">
                      <div className="flex">
                        <div className="nomination-status">
                          {getStatusIcon(x.ReviewStatus)}
                          <div>{x.ReviewScore && <>{x.ReviewScore}</>}</div>
                          <br />
                          <Button
                            type="edit"
                            text="Review"
                            extraSmall={true}
                            onClick={() => {
                              setSelectedNomination(x);
                              setSelectedProject(project);
                              setSelectedAward(award);
                              setModalOpen(true);
                            }}
                          />
                        </div>
                        <div>
                          <div className="project-id">
                            {project.projectId}
                        {project.affiliateCode && <span className="affiliate-code">{project.affiliateCode}</span>}
                            {'  '}
                            <Button
                              type="details"
                              extraSmall={true}
                              iconOnly={true}
                              onClick={() => {
                                setSelectedProject(project);
                                setShowShowcase(true);
                              }}
                            />
                          </div>
                          <div className="nomination-type">Type: {x.NominationType}</div>
                          <div className="nomination-category">{project.categoryName}</div>
                          {mapRankings(project.id)}
                        </div>
                      </div>
                      <div className="title" dangerouslySetInnerHTML={{ __html: sanitizeHtml(project.title) }}></div>
                    </div>
                  </div>
                );
              })}
          </div>
        );
    }
  };

  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'Pending':
        return (
          <div className="label label-warning">
            <Icon type={IconType.pending} /> Pending
          </div>
        );
      case 'Approved':
        return (
          <div className="label label-success">
            <Icon type={IconType.agree} /> Approved
          </div>
        );
      case 'Rejected':
        return (
          <div className="label label-danger">
            <Icon type={IconType.cancel} /> Rejected
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <div>
        <div className="flex-between">
          <h3>Review Nominations</h3>
          <Button onClick={init} text="Refresh" type="refresh" />
        </div>
        <div className="search-bar flex-between">
          <div className="flex">
            <label className="control-label" htmlFor="search-it">
              Search {'  '}
            </label>
            <div className="bumper-left">
              <CreatableSelect
                options={searchOptions}
                id="search-it"
                onChange={(x: any) => {
                  setSelectedOptions(x);
                }}
                value={selectedOptions}
                isMulti={true}
                autoFocus={true}
                placeholder="Search by Award, project, or nomination status"
              />
            </div>
          </div>
          <div>
            <Select
              options={groupOptions}
              id="sort-it"
              onChange={(x: any) => {
                setGroupBy(x);
              }}
              value={groupBy}
              isMulti={false}
              placeholder="Group By"
            />
          </div>
          <div className="flex">
            <div className="bumper-right">
              <Button
                type="down"
                iconOnly={true}
                disabled={currentPage === 1}
                onClick={() => {
                  setCurrentPage(currentPage - 1);
                }}
              />
              Page {currentPage} of {totalPages}
              <Button
                type="up"
                iconOnly={true}
                disabled={currentPage === totalPages}
                onClick={() => {
                  setCurrentPage(currentPage + 1);
                }}
              />
            </div>
            <Select
              options={sortOptions}
              id="sort-it"
              onChange={(x: any) => {
                setSortOption(x);
              }}
              value={sortOption}
              isMulti={false}
              placeholder="Sort By"
            />
          </div>
        </div>
        {mapNominations()}
      </div>
      {modalOpen && (
        <Modal setModalOpen={setModalOpen} title={`Nomination for ${selectedAward}`} size="xl">
          <div className="form-horizontal">
            <div className="form-group">
              <label className="control-label col-sm-3" htmlFor="project-id">
                Project
              </label>
              <div className="col-sm-8">
                <input id="project-id" type="text" className="form-control" value={selectedProject?.projectId} readOnly={true} />
              </div>
            </div>
            <div className="form-group">
              <label className="control-label col-sm-3" htmlFor="project-title">
                Title
              </label>
              <div className="col-sm-8">
                <input id="project-title" type="text" className="form-control" value={selectedProject?.title} readOnly={true} />
              </div>
            </div>
            <div className="form-group">
              <label className="control-label col-sm-3" htmlFor="nomination-type">
                Nomination Type
              </label>
              <div className="col-sm-8">
                <input id="nomination-type" type="text" className="form-control" value={selectedNomination?.NominationType} readOnly={true} />
              </div>
            </div>
            <div className="form-group">
              <label className="control-label col-sm-3" htmlFor="nomination-reason">
                Reason
              </label>
              <div className="col-sm-8">
                <textarea id="nomination-reason" className="form-control" rows={6} value={selectedNomination?.Reason} readOnly={true} />
              </div>
            </div>
            <div className="form-group">
              <label className="control-label col-sm-3" htmlFor="nomination-review-notes">
                Review Notes
              </label>
              <div className="col-sm-8">
                <textarea
                  id="nomination-review-notes"
                  className="form-control"
                  rows={6}
                  value={selectedNomination?.ReviewNotes}
                  onChange={(x) => {
                    let newNom = { ...selectedNomination };
                    newNom.ReviewNotes = x.target.value;
                    setSelectedNomination(newNom);
                  }}
                />
              </div>
            </div>
            <div className="form-group">
              <label className="control-label col-sm-3" htmlFor="nomination-review-status">
                Review Status
              </label>
              <div className="col-sm-8">
                <Select
                  options={StatusOptions.map((x) => {
                    return { value: x, label: x };
                  })}
                  value={{ value: selectedNomination?.ReviewStatus, label: selectedNomination?.ReviewStatus }}
                  onChange={(x: any) => {
                    let newNom = { ...selectedNomination };
                    newNom.ReviewStatus = x.value;
                    setSelectedNomination(newNom);
                  }}
                />
              </div>
            </div>
            <div className="form-group">
              <label className="control-label col-sm-3" htmlFor="nomination-review-score">
                Review Score
              </label>
              <div className="col-sm-8">
                <input
                  id="nomination-review-score"
                  type="number"
                  className="form-control"
                  value={selectedNomination?.ReviewScore}
                  onChange={(x) => {
                    let newNom = { ...selectedNomination };
                    newNom.ReviewScore = x.target.value;
                    setSelectedNomination(newNom);
                  }}
                />
              </div>
            </div>
            <div className="form-group">
              <div className="col-sm-offset-3 col-sm-8">
                <div className="btn-group">
                  <Button text="Save" type="save" onClick={saveReview} />

                  <Button
                    type="details"
                    text="View  Entry"
                    onClick={() => {
                      setShowShowcase(true);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal>
      )}
      {showShowcase && selectedProject && (
        <Modal setModalOpen={setShowShowcase} title={'Entry Details'} size="xxl">
          <ProjectDetailsWraper ProjectKey={selectedProject.projectKey} />
        </Modal>
      )}
    </>
  );
};

export default ReduxMap(NominationsReview);
